<template>
    <div class="container">
        <div class="body">
            <headerDiv />
                <div class="total">
                    <div class="one">
                        <p class="p">{{$t('register.one')}}</p>
                        <div class="two Margin" style="margin-top:35px;">
                            <span class="cur">*</span>
                            <input type="text" :placeholder="$t('toast.username')"  v-model="username" />
                        </div>
                        <div class="three Margin">
                            <span class="cur">*</span>
                            <input type="text" :placeholder="$t('toast.phone')" v-model="phone">
                        </div>
                        <div class="two Margin">
                            <span class="cur">*</span>
                            <input type="password" name="" id="" v-model="userpwd" :placeholder="$t('toast.userpwd')">
                        </div>
                        <div class="three Margin">
                            <span class="cur">*</span>
                            <input type="password" name="" id="" v-model="userpwdpwd" :placeholder="$t('toast.userpwdpwd')">
                        </div>
                        
                        <div class="three Margin">
                            <span class="cur">*</span>
                            <input type="text" :placeholder="$t('toast.email')"  v-model="email" oninput="value=value.replace(/\s+/g,'')" >
                        </div>
                        <div class="five Margin">
                            <input type="text" v-model="ReferenceNumber" :placeholder="$t('toast.ReferenceNumber')">
                            <p>{{$t('register.four')}}</p>
                        </div>
                        <div class="six Margin">
                            <div>
                                <div class="check1" @click="dj(four=0)" v-show="one"></div>
                                <div class="check2" @click="dj(four=1)" v-show="two"><img src="../../../assets/images/gou.png" alt="" style="margin: 3px 0 0 4px;"/></div>
                            </div>
                            <span @click="modal1=true">{{$t('register.five')}} <span style="color:red;margin-left:-5px">《承運條款》</span></span>
                        </div>
                        <div class="logon" @click="denglu()">{{$t('register.six')}}</div>
                        <div class="border" @click="register()">{{$t('register.Seven')}}</div>
                    </div>
                </div>
        </div>
    <!-- 对话框 -->
    <Modal
        v-model="modal1"
        title="集運服務條款細則"
        width="800"
        ok-text="確定"
        cancel-text="取消"
        >
    <div>
        一 關於時效<br><br>
        <p>1.集運截單時間爲<span class="Modal">（周日至周五）每天淩晨12點</span>，週六及香港假期前一天除外。截單時間前完成付款當天（工作日）安排發貨。中轉站週六及香港紅日前一天均不發貨，周天或公眾假期香港派送公司不予貨物派送。節假日具體安排請留意集運官網</p><br>
        <p>2.集運訂單發貨後正常隔天到港。到港後訂單一般當天（工作日）派送，偏遠地區一般需要隔天派送。特殊情況：當遇上天氣惡劣/海關查處/雨天/公眾假期/偏遠地區/6.18/雙11/雙12等情況，爲了保證貨物安全，貨物可能會延遲派送，特殊情況請留意集運官網公告。</p>
    </div>

    </Modal>
  </div>
</template>
<script>
// import {GVerify} from "./code.js"
import md5 from "js-md5";
import headerDiv from "../../layout/header/index.vue"
export default {
    data(){ 
        return{
            modal1:false,
            username:'',
            userpwd:'',
            userpwdpwd:'',
            phone:'',
            model1: '',
            four:0,
            one:true,
            two:false,
            ReferenceNumber:'',
            syck:[],
            email:''
        }
    },
    components: {
    headerDiv,
  },
    mounted(){
        this.queryUrl();
        const id = this.$route.query.id
        if(id){
           this.ReferenceNumber=id
        }
    },
    methods:{
      denglu(){
        this.$router.push('./login')
      },
      dj(){
          if(this.four == 0){
              this.one = false;
              this.two = true;
          }else if(this.four == 1){
              this.one = true;
              this.two = false;
          }
      },
         async queryUrl() {
      const _md5 = md5('{"Url":"vip.paibaoex.com"}123456');
      const params = {
        JsonData: '{"Url":"vip.paibaoex.com"}',
        CusID: 28,
        KeyMd5: _md5,
      };
      const { data } = await this.$post("/QueryUrl", params, true);
      if (data.State) {
        const storeInfo = JSON.parse(data.ReturnJson);
          document.title = storeInfo.Name
        localStorage.setItem("CusID", storeInfo.CusID);
        localStorage.setItem("shopName", storeInfo.Name);
        localStorage.setItem("KeyText", storeInfo.KeyText);
        localStorage.setItem("phone", storeInfo.Phone);
      }
    },
      async register(){
            // 手机号
          if(this.username==''){
            this.$Message.error('请填写完整');
            return false
          }else if(this.username.length<2){
              this.$Message.error("用户名不能小于两位");
              return false;
          }else if(this.userpwd==''){
            this.$Message.error('请填写完整')
            return false
          }else if(this.userpwd.length<6){
            this.$Message.error('密码位数不能低于6位！')
            return false
          }else if(this.userpwdpwd != this.userpwd){
            this.$Message.error('两次密码不一置！')
            return false
          }else if(this.phone==''){
            this.$Message.error('邮箱不能为空')
            return false
          }else if(this.two == true){
                const params = {
                    ReferenceNumber:this.ReferenceNumber,
                    ClientName:this.username,
                    Email:this.phone,
                    Mobil:this.email,
                    Password:this.userpwdpwd,
                    RePassword:this.userpwdpwd,
                    WeiboId:"",
                    enname:""
                };
                const { data } = await this.$post("Client_Registered", params);
                if(data.State){
                    this.$Message.success('注册成功！')
                    this.$router.push('./login')
                }else{
                    this.$Message.error(data.MsgText);
                    return false;
                }
            }else{
                this.$Message.error("请阅读并同意《承运条款》");
            }
          },
      }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-modal-content{
    font-size: 18px;
}
    /deep/ .ivu-modal-content  .Modal{
        color:red !important;
    }
    /deep/ .ivu-modal-content  .ModalA{
        color:red !important;
        text-decoration: underline;
        cursor: pointer;
    }
    /deep/.ivu-modal-body{
        font-size: 14px;
    }
    .container {
        width: 100%;
        @include backgroundColor($_color);
        height: 100vh;
        .body{
            background: url('../../../assets/images/bg.png')no-repeat center center;
            height: 100vh;width:100%;
            background-size: 100% 100%;
        }
        ::-webkit-input-placeholder::before {
            content: "*";
            display: inline-block;
            margin-right: 4px;
            line-height: 1;
            font-family: SimSun;
            font-size: 12px;
            color: #ed4014;
        }
        .total{
            width: 100%;
            display: flex;
            padding-bottom:20px;
            justify-content: flex-end;
            .one{
                width: 500px;
                height: 600px;
                background: #fff;    
                box-shadow: 0px 0px 30px 0px rgba(35, 21, 24, 0.35);
                border-radius: 20px;
                margin: 80px 190px 0 0;
                padding: 0 54px;
                position: relative;
                .Margin{
                    margin: 10px 0;
                    position: relative;
                    .cur {
                        position: absolute;
                        top: 8px;
                        left: -16px;
                        color: #f00;
                        font-size: 28px;
                    }
                    
                }
                .logon{
                    position:absolute;
                    bottom: 16px;
                    right: 50px;
                    text-decoration: underline;
                    color: red;
                    font-size: 20px;
                    cursor: pointer;
                }
                .p{
                    font-size: 32px;
                    font-weight: bold;
                    color: #333;
                    padding: 28px 0 0 0;
                    text-align: center;
                }
                .pdw{
                    font-size: 14px;
                    font-weight: 500;
                    color: #0099ff;
                    margin: -29px 0 0 0;
                    cursor: pointer;
                }
                .two{
                    // margin: 0px 0 5px 0;
                    input{
                        width: 390px;
                        height: 43px;
                        background: #fafafa;
                        border: 2px solid #e4e4e4;
                        opacity: 0.6;
                        border-radius: 5px;
                        text-indent: 1em;
                    }
                    p{
                        font-size: 12px;
                        color: red;
                        cursor: pointer;
                        padding: 5px 0 0 0;
                    }
                }
                .three{
                    // margin: 0 0 10px 0;
                    p{color: red;}
                    .span::before {
                        content: "*";
                        display: inline-block;
                        margin-right: 4px;
                        line-height: 1;
                        font-family: SimSun;
                        font-size: 12px;
                        color: #ed4014;
                    }
                    input{
                        width: 390px;
                        height: 43px;
                        background: #fafafa;
                        border: 2px solid #e4e4e4;
                        opacity: 0.6;
                        border-radius: 5px;
                        text-indent: 1em;
                    }
                }
                /deep/ .four{
                    display: flex;
                    flex-direction: row;
                    // margin: 30px 0 0 0;
                    input{
                        width: 293px;
                        height: 60px;
                        background: #fafafa;
                        border: 2px solid #e4e4e4;
                        opacity: 0.6;
                        border-radius: 5px;
                        text-indent:1em;
                        margin: 0 0 0 10px;
                    }
                    .code{
                        width: 156px;
                        height: 60px;
                        background: #fafafa;
                        border: 2px solid #e4e4e4;
                        opacity: 0.6;
                        border-radius: 5px;
                    }
                    #verifyCanvas{
                        width: 153px;
                        height: 56px;
                    }
                     .ivu-select-selected-value{
                        display: block;
                        height: 41px;
                        line-height: 60px;
                        font-size: 20px;
                    }
                     .ivu-select-single .ivu-select-selection{
                        position: relative;
                        height: 58px;
                    }
                     .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{font-size: 20px;line-height: 60px;height: 40px;color:#999;}
                }
                .five{
                    margin: 5px 0 0px 0;
                    input{
                        width: 390px;
                        height: 43px;
                        background: #fafafa;
                        border: 2px solid #e4e4e4;
                        opacity: 0.6;
                        border-radius: 5px;
                        text-indent: 1em;
                    }
                    p{
                        font-size: 12px;
                        color: #999;
                        padding: 5px 0 0 0;
                    }
                }
                .six{
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    margin: 10px 0 0 10px;
                    .check1{
                        width: 19px;
                        height: 19px;
                        background: #fff;
                        border-radius: 50%;
                        border: 1px solid #c2c2c2;
                        position: absolute;
                        top: 0;
                    }
                    .check2{
                        width: 19px;
                        height: 19px;
                        background: red;
                        border-radius: 50%;
                        position: absolute;
                        top: 0;
                    }
                    span{
                        margin: 0 0 0 25px;
                        cursor: pointer;
                        font-weight: 500;
                        color:#000;
                        // width: 100px;
                        // text-decoration: underline;
                    }
                }
                .border{
                    width: 230px;
                    height: 60px;
                    background: #7966fe;
                    border-radius: 10px;
                    font-size: 36px;
                    text-align: center;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 60px;
                    margin: 18px 0 0 82px;
                    cursor: pointer;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/view/signup/register.vue